import { Component } from '@angular/core';
@Component({
	templateUrl: './financeiro.component.html',
})

export class FinanceiroComponent{
}